import React from 'react'
import SectionBlock from './template/SectionBlock'
import SectionHeading from './template/SectionHeading'
import Heading from './template/Heading'
import Description from './template/Description'
import GotoEndpoint from './template/GotoEndpoint'

export default function AboutMe() {
    return (
        <SectionBlock key={2} className='grid-cols-1 gap-x-8 py-12 pb-12 text-center lg:grid-cols-2 lg:gap-x-12 lg:pb-20 lg:text-left'>
            <SectionHeading number='02' content="About Me" className='col-span-1 justify-center -mb-2 lg:col-span-2 lg:justify-start' />
            <div className='self-start lg:mr-10'>
                <Heading className='mx-auto  max-w-[16ch] sm:max-w-[14ch] md:max-w-[12ch] lg:mx-0'>AI-augmented full-stack engineer</Heading>
            </div>
            <div className='self-start'>
                <Description className='mx-auto w-full max-w-xl text-secondary leading-7 sm:text-lg lg:mx-0 lg:mt-0 lg:w-2/3'>
                    I work across React, Next.js, Node.js, Python, cloud tooling, and AI-assisted workflows to build products that are scalable, high-performing, and easier for people to use.
                    <br />
                    <br />
                    My focus is turning technical depth into products that feel fast, clear, and genuinely useful for the people relying on them.
                </Description>
                <GotoEndpoint key={"aboutme endpoint"} content='More About Me' endpoint='/about' className='inline-flex items-center text-base sm:text-lg' />
            </div>
        </SectionBlock>
    )
}
